import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPhysicianAutocomplete(inputValue) {
    return useQuery(['physicianAutocomplete', inputValue], () => PESService.searchPhysician(inputValue), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        staleTime: 60 * 1000,
    });
}

export default useFetchPhysicianAutocomplete;
